import { propertyValue } from './dood-block-config';

/** Shared top-spacing choices for kiosk cart-funnel blocks. `auto` keeps the legacy CSS. */
export const KIOSK_CART_FUNNEL_TOP_PADDING_VALUES = [
  'auto',
  'none',
  'small',
  'medium',
  'large',
  'xlarge',
] as const;

export type KioskCartFunnelTopPadding = (typeof KIOSK_CART_FUNNEL_TOP_PADDING_VALUES)[number];

function kioskCartFunnelPaddingProperty(blockKey: string, edge: 'top' | 'bottom') {
  const option = (value: KioskCartFunnelTopPadding) => ({
    value,
    label: `pages.blocks.${blockKey}.${edge}-padding.options.${value}`,
  });

  return propertyValue({
    type: 'select',
    value: 'auto' satisfies KioskCartFunnelTopPadding,
    options: {
      label: `pages.blocks.${blockKey}.${edge}-padding.label`,
      help: `pages.blocks.${blockKey}.${edge}-padding.help`,
      multiple: false,
      choices: KIOSK_CART_FUNNEL_TOP_PADDING_VALUES.map(option),
    },
  });
}

export function kioskCartFunnelTopPaddingProperty(blockKey: string) {
  return kioskCartFunnelPaddingProperty(blockKey, 'top');
}

export function kioskCartFunnelBottomPaddingProperty(blockKey: string) {
  return kioskCartFunnelPaddingProperty(blockKey, 'bottom');
}
